import React from 'react';
import { Link } from 'react-router-dom';

const SubNavigation = ({ isAdmin }) => {
  return (
    <div>
      {isAdmin && (
        <>
          <p className="text-neutral-grey">PROGRAM PORTAL</p>
          <p>
            <Link to="/Administration/occupancy">Occupancy Management</Link>
          </p>
          <p>
            <Link to="/Administration/premium-distribution">
              Premium distributions
            </Link>
          </p>
          <p>
            <Link to="/Administration/exclusion-sets"> Exclusion sets </Link>
          </p>
          <p>
            <Link to=""> Emails </Link>
          </p>
          <p>
            <Link to=""> Email configuration </Link>
          </p>
          <p>
            <Link to="/Administration/certificate"> Program Certificate </Link>
          </p>
          <p>
            <Link to="/Administration/lookup-groups"> Lookup Groups </Link>
          </p>
          <p>
            <Link to="/Administration/user-manual"> User manual </Link>
          </p>

          <hr />
        </>
      )}
      {isAdmin && (
        <>
          <p className="text-neutral-grey">PARENT COMPANY</p>
          <p>
            <Link to="/Administration/parentCompany"> Parent company </Link>
          </p>
        </>
      )}
    </div>
  );
};

export default SubNavigation;
